import { render, staticRenderFns } from "./termsAcceptDialog.vue?vue&type=template&id=5d21375c&lang=pug"
import script from "./termsAcceptDialog.vue?vue&type=script&lang=js"
export * from "./termsAcceptDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports